import { c as _c } from "react/compiler-runtime";
import type { AuditEventDetail } from '@onefootprint/request-types/dashboard';
import capitalize from 'lodash/capitalize';
import { useTranslation } from 'react-i18next';
import RoleDisplay from '../role-display/role-display';
type CreateOrgRoleProps = {
  detail: AuditEventDetail;
  hasPrincipalActor: boolean;
};
const CreateOrgRole = t0 => {
  const $ = _c(12);
  const {
    detail,
    hasPrincipalActor
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.roles"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  if (detail.kind !== "create_org_role") {
    return null;
  }
  const {
    roleName,
    scopes
  } = detail.data;
  let t2;
  if ($[1] !== hasPrincipalActor || $[2] !== t) {
    t2 = hasPrincipalActor ? t(_temp) : capitalize(t(_temp2));
    $[1] = hasPrincipalActor;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <span className="text-body-2 text-tertiary">{t2}</span>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== roleName || $[7] !== scopes) {
    t4 = <RoleDisplay name={roleName} scopes={scopes} isNew={true} />;
    $[6] = roleName;
    $[7] = scopes;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default CreateOrgRole;
function _temp($) {
  return $.createdANew;
}
function _temp2($_0) {
  return $_0.createdANew;
}